// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__6kyfP","selected":"Pagination_selected__1RXBR","dots":"Pagination_dots__vitDO"};